/** Shared names for Your Collections: the All sounds URL value, queue keys and the All sounds list query. */
import type { ListTracksParams } from '@/api/audioStudioApi';
import type { SoundsScope } from './SoundRows';

export const EMPTY_COLLECTION_TEXT = 'Add sounds from All sounds or Recent creations with ⋯ → Add to collection';
/** `&collection=all` opens the All sounds page. */
export const ALL_SOUNDS = 'all';
/** Queue keys: a list's Play button knows it is the one in the player. */
export const allSoundsQueueKey = 'collection:all';
export const collectionQueueKey = (id: string) => `collection:${id}`;
/** What the All sounds card, its page and its Play button list (the same query, so they share the cache). */
export const allSoundsParams = (brandId: string | null, scope: SoundsScope = 'team'): ListTracksParams => ({ scope, brand_id: brandId || undefined, limit: 50, offset: 0 });
